

<template lang='pug'>
.success-container
        img(:src="require(`@/assets/imgs/${src}`)" :style='{height:height}')
        .content {{name}}
</template>

<script>
export default {
    props:['height','src','name']
,
data(){
    return {
    }
},
    created() {
    }
}
</script>

<style scoped lang='less'>
 .success-container{
        display: flex;
        align-items: center;
        height: 0.9rem;

        img{
            margin-right: 0.3rem;
        }
        .content{
            color: #00448a;
        }

    } 
</style>